import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StyledScrollContainer } from '../../../components/StyledScrollContainer'

// @components
import {
    Button,
    Typography,
    Card,
} from "@material-tailwind/react";
import { Refresh } from "iconoir-react";
import { RootState } from '../../../redux';
import { listTradeinRequest, TradeinRequest } from '../../../redux/auth/actions';

const TABLE_HEAD = [
    {n: "Email", className: "pl-4"},
    {n: "VIN", className: "pl-4"},
    {n: "Zip Code", className: "pl-4"},
    {n: "Date Added", className: "pl-4"},
];

export const DashboardTradeInForm = () => {
    const dispatch = useDispatch();
    const { tradein_requests } = useSelector((state: RootState) => state.auth);

    const handleRefresh = () => {
        dispatch(
            listTradeinRequest()
        );
    };

    useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <Card>
                <Card.Header className="w-full m-0 items-center rounded-none flex  justify-between p-4">
                    <div className="grow">
                        <Typography
                            type="lead"
                            color="default"
                            className="font-semibold mb-1"
                        >
                            Trade-In Request
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            All trade-in requests
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Button
                            variant="outline"
                            color="secondary"
                            className="flex items-center gap-2 sm:w-auto w-full"
                            onClick={() => {
                                handleRefresh();
                            }}
                        >
                            <Refresh className="w-4 h-4" />
                        </Button>
                    </div>
                </Card.Header>
                <StyledScrollContainer className="max-h-[400px]">
                    <Card.Body className="p-0 rounded-none">
                        <table className="w-full min-w-max table-auto text-left">
                            <thead>
                                <tr>
                                    {TABLE_HEAD.map((head, idx:number) => (
                                        <th key={idx} className={`border-b border-surface p-4 ${head.className}`}>
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head.n}
                                            </Typography>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tradein_requests?.map((el: TradeinRequest, key: number) => (
                                    <tr key={key} className="group cursor-pointer">
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground font-bold">
                                                {el?.email || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground">
                                                {el?.vin || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground">
                                                {el?.zip_code || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground">
                                                {el?.date_added || 'N/A'}
                                            </Typography>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </StyledScrollContainer>
            </Card>
        </div>
    );
};

export default DashboardTradeInForm;